import accessLevel from './accessLevel/actions'
import homePage from './homePage/actions'
import projectPage from './projectPage/actions'
import adminPage from './adminPage/actions'


export default {
  accessLevel,
  homePage,
  projectPage,
  adminPage,
}
